__turbopack_context__.v({
  "footer": "QDhe8q_footer",
  "label": "QDhe8q_label",
  "root": "QDhe8q_root",
});
